import React, { useEffect } from 'react';
import { Translate } from '../common/WithTranslate';
import { ProgressionDialog, useProgressionDialogState } from '../common/dialog/ProgressionsDialog';
import { TLCode } from '../../common/enums';

interface PasswordResetConfirmationProps {
  translate: Translate;
  inProgress: boolean;
  inError: boolean;
  done: boolean;
  onClose: () => void;
}

export const PasswordResetConfirmation = ({
  translate,
  inProgress,
  inError,
  done,
  onClose,
}: PasswordResetConfirmationProps) => {
  const progressionDialogState = useProgressionDialogState();

  const doneText = translate(TLCode.LOGIN_NewPasswordSent);
  const errorText = translate(TLCode.LOGIN_NewPasswordError);
  const titleText = translate(TLCode.LOGIN_NewPasswordProgressTitle);
  const closeButtonText = translate(TLCode.Close);

  useEffect(() => {
    if (inProgress) progressionDialogState.setInProgress();
  }, [inProgress, progressionDialogState.setInProgress]);

  useEffect(() => {
    if (inError) progressionDialogState.setInError();
  }, [inError, progressionDialogState.setInError]);

  useEffect(() => {
    if (done) progressionDialogState.setDone();
  }, [done, progressionDialogState.setDone]);

  return (
    <ProgressionDialog
      inProgress={progressionDialogState.inProgress}
      inError={progressionDialogState.inError}
      done={progressionDialogState.done}
      titleText={titleText}
      doneText={doneText}
      errorText={errorText}
      closeButtonText={closeButtonText}
      onClose={() => {
        progressionDialogState.reset();
        onClose();
      }}
    />
  );
};
